<template>
  <div class="custom-checkbox-group" :data-test="dataTest">
    <v-checkbox
      v-for="item in items"
      :key="item.value"
      v-model="checkedValues"
      :label="item.label"
      :value="item.value"
      :data-test="`${dataTest}-option-${item.value}`"
      hide-details
      density="compact"
      @update:model-value="handleChange"
    ></v-checkbox>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    items: Array<{ label: string; value: string }>;
    value: string[];
    onChange: (value: string[]) => void;
    dataTest?: string;
  }>(),
  { dataTest: 'checkbox-group-input' },
);

const checkedValues = ref<string[]>([...props.value]);

watch(
  () => props.value,
  (value) => {
    checkedValues.value = [...value];
  },
);

// Vuetify types the emit as nullable, though an array v-model always emits an array.
const handleChange = (value: string[] | null): void => {
  props.onChange([...(value ?? [])]);
};
</script>

<style lang="postcss" src="../selection-group.css"></style>
